export default __webpack_public_path__ + "static/media/snowuns-text1.c9a9457e.png";